import maplibregl from "maplibre-gl";
/* @ts-ignore */
import * as osmLiberty from "osm-liberty/style.json";

export function createMap(
    maptilesBaseUrl: any,
    mapOptions: any = {}
) {
    const center = mapOptions.center || [13.1, 51.1];
    const zoom = mapOptions.zoom || 9;

    /*
     * we use osm-liberty as our default style
     * unless the project provides its own style
     * and overwrite that to point to our own server
     */
    let style = mapOptions.style || osmLiberty;

    /*
     * since we are compiling the library in strict mode
     * and there is no setter defined on the imported json style definition
     * we clone all properties to a new object
     * so we can set the sources property
     */
    style = Object.assign({}, style)

    style.sources = {
        openmaptiles: {
            // NOTE: we need to attribute OpenMapTiles and OpenStreetMap correctly to comply with the license (we automatically do this below)
            /* @ts-ignore */
            attribution: '<a href="https://maps.sandstorm.de" title="Sandstorm Maps" target="_blank">Sandstorm Maps</a> <a href="https://www.openmaptiles.org/" target="_blank">&copy; OpenMapTiles</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>',
            type: "vector",
            /* @ts-ignore */
            maxzoom: 14,
            tiles: [
                maptilesBaseUrl + "/services/planet-230109/tiles/{z}/{x}/{y}.pbf",
            ],
        },
    };
    style.glyphs = maptilesBaseUrl + "/fonts/{fontstack}/{range}.pbf";
    style.sprite = maptilesBaseUrl + "/frontend/v1/sprites/osm-liberty";

    style.layers = style.layers.filter(
        (el: any) => el.source !== "natural_earth_shaded_relief"
    );

    const map = new maplibregl.Map({
        ...mapOptions,
        style,
        center,
        zoom,
    });

    return map;
};